// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Mobile layer — makes existing pages usable on phones without
   touching each page. New pages should still be built mobile
   first with <Col xs={24} md={...}>, not rely on these rescues.
   ============================================================ */

@media (max-width: 767.98px) {
  /* ── Dialogs become bottom sheets ───────────────────────── */
  /* Anchored to the bottom, as tall as their content (up to just under the status bar); the
     body scrolls between a fixed header and footer so actions stay under the thumb. Inline
     top/width/max-height set by individual modals are overridden. */
  .ant-modal:not(.ant-modal-confirm) {
    position: fixed !important;
    inset: auto 0 0 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    max-height: calc(100dvh - var(--ds-safe-top) - 12px) !important;
    min-height: 0 !important;
    overflow: visible !important;
    margin: 0 !important;
    padding: 0 !important;
    transform-origin: 50% 100% !important;
  }

  .ant-modal:not(.ant-modal-confirm) > div,
  .ant-modal:not(.ant-modal-confirm) .ant-modal-content {
    max-height: inherit;
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-content {
    display: flex;
    flex-direction: column;
    border-radius: var(--ds-radius-xl) var(--ds-radius-xl) 0 0;
    overflow: hidden !important;
  }

  /* Grab handle */
  .ant-modal:not(.ant-modal-confirm) .ant-modal-content::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 50%;
    width: 40px;
    height: 5px;
    margin-left: -20px;
    border-radius: 999px;
    background: var(--ds-border);
    z-index: 3;
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-header {
    flex: 0 0 auto;
    padding: 22px 60px 12px 20px;
  }

  [dir="rtl"] .ant-modal:not(.ant-modal-confirm) .ant-modal-header {
    padding: 22px 20px 12px 60px;
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-close {
    top: 16px;
    inset-inline-end: 12px;
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-body {
    flex: 1 1 auto;
    min-height: 0 !important;
    max-height: none !important;
    overflow-y: auto !important;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    padding: var(--ds-space-4) var(--ds-space-5) var(--ds-space-5);
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-footer {
    flex: 0 0 auto;
    padding: var(--ds-space-3) var(--ds-space-4) calc(var(--ds-space-3) + var(--ds-safe-bottom));
    background: var(--ds-surface);
    box-shadow: 0 -6px 16px rgba(19, 33, 44, 0.05);
  }

  .ant-modal:not(.ant-modal-confirm) .ant-modal-footer .ant-btn {
    flex: 1 1 0;
    height: 48px;
  }

  /* Slide up instead of zooming */
  .ant-modal.ant-zoom-enter:not(.ant-modal-confirm),
  .ant-modal.ant-zoom-appear:not(.ant-modal-confirm) {
    animation-name: ds-sheet-in !important;
    animation-duration: 0.28s !important;
    animation-timing-function: var(--ds-ease) !important;
  }

  .ant-modal.ant-zoom-leave:not(.ant-modal-confirm) {
    animation-name: ds-sheet-out !important;
    animation-duration: 0.2s !important;
  }

  /* Confirm dialogs stay centered dialogs, just fit the screen */
  .ant-modal.ant-modal-confirm {
    max-width: calc(100vw - 32px) !important;
    margin: 0 auto;
  }

  .ant-modal-confirm .ant-modal-confirm-btns {
    display: flex;
    gap: var(--ds-space-2);
  }

  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
    flex: 1 1 0;
    height: 44px;
    margin: 0 !important;
  }

  /* ── Drawers never exceed the viewport ─────────────────────── */
  .ant-drawer-content-wrapper {
    max-width: 100vw;
  }

  .ant-drawer-right > .ant-drawer-content-wrapper,
  .ant-drawer-left > .ant-drawer-content-wrapper {
    width: min(100vw, var(--ds-drawer-w, 100vw)) !important;
  }

  .ant-drawer-body {
    padding: var(--ds-space-4);
  }

  /* ── Forms: multi-column rows stack into one column ────────── */
  /* Columns that already declare an xs size are left alone. */
  .ant-form .ant-row:not(.ant-form-item-row) > .ant-col:not([class*="ant-col-xs-"]),
  .ant-modal-body
    .ant-row:not(.ant-form-item-row)
    > .ant-col[class*="ant-col-"]:not([class*="ant-col-xs-"]) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .ant-form-horizontal .ant-form-item-row {
    flex-direction: column;
    align-items: stretch;
  }

  .ant-form-horizontal .ant-form-item-label,
  .ant-form-horizontal .ant-form-item-control {
    flex: 0 0 auto !important;
    max-width: 100% !important;
    text-align: start;
  }

  /* Fields hard-coded to desktop pixel widths shrink to the screen */
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-select,
  .ant-picker,
  .ant-picker-range,
  .ant-input-group-wrapper {
    max-width: 100%;
  }

  /* iOS zooms into any field under 16px */
  input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
  textarea,
  select {
    font-size: 16px;
  }

  /* Range pickers: show one month at a time */
  .ant-picker-dropdown .ant-picker-panels {
    flex-direction: column;
  }

  .ant-picker-dropdown .ant-picker-range-wrapper {
    max-width: calc(100vw - 16px);
  }

  /* ── Tables ────────────────────────────────────────────────── */
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    white-space: nowrap;
  }

  .ant-table-pagination.ant-pagination {
    justify-content: center;
    flex-wrap: wrap;
    row-gap: var(--ds-space-2);
  }

  .ant-pagination-options-size-changer,
  .ant-pagination-options-quick-jumper {
    display: none !important;
  }

  /* ── Descriptions: label above value instead of a wide grid ── */
  .ant-descriptions-bordered .ant-descriptions-view > table,
  .ant-descriptions-bordered .ant-descriptions-view > table > tbody,
  .ant-descriptions-bordered .ant-descriptions-row,
  .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-descriptions-bordered .ant-descriptions-item-content {
    display: block;
    width: 100%;
  }

  .ant-descriptions-bordered .ant-descriptions-item-label {
    border-inline-end: none !important;
    padding-bottom: var(--ds-space-1) !important;
  }

  /* ── Page toolbars stack; primary actions become full width ── */
  .top-right-stuff {
    float: none !important;
  }

  .top-right-stuff .ant-flex {
    flex-direction: column;
    align-items: stretch;
    padding: var(--ds-space-3);
  }

  .top-right-stuff .ant-btn,
  .top-right-stuff .ant-input-search,
  .top-right-stuff .ant-select {
    width: 100% !important;
  }

  /* ── Tabs: horizontally scrolling pills ───────────────────── */
  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab {
    padding: 8px 14px;
    border-radius: 999px;
    background: var(--ds-surface);
    border: 1px solid var(--ds-border-soft);
    font-size: 0.875rem;
  }

  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
    margin-inline-start: 8px;
  }

  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-active {
    background: var(--ds-heading);
    border-color: var(--ds-heading);
  }

  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #fff !important;
  }

  /* Labels wrapped in a Badge (counts) set their own text color; follow the pill instead. */
  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-btn .ant-badge {
    color: inherit;
  }

  .ant-tabs > .ant-tabs-nav {
    margin-bottom: var(--ds-space-4);
  }

  /* ── Cards ─────────────────────────────────────────────────── */
  .ant-card .ant-card-body {
    padding: var(--ds-space-4);
  }

  .ant-card .ant-card-head {
    padding: 0 var(--ds-space-4);
    flex-wrap: wrap;
  }

  /* ── Calendars ─────────────────────────────────────────────── */
  .fc .fc-toolbar {
    flex-wrap: wrap;
    gap: var(--ds-space-2);
  }

  .fc .fc-toolbar-title {
    font-size: 1.05rem;
  }

  .fc .fc-button {
    padding: 6px 10px;
  }

  /* ── Media never overflows ─────────────────────────────────── */
  .app-content img,
  .app-content video,
  .app-content iframe {
    max-width: 100%;
  }
}

/* Touch devices: no hover lift/scale effects, bigger hit areas */
@media (hover: none) {
  .ant-btn:hover,
  .ant-card:hover {
    transform: none !important;
  }

  .ant-checkbox-wrapper,
  .ant-radio-wrapper {
    min-height: 32px;
    align-items: center;
  }
}

@keyframes ds-sheet-in {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes ds-sheet-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/design-system/responsive.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,8DAA8D;EAC9D;;oEAEkE;EAClE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,+DAA+D;IAC/D,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;IACrB,qCAAqC;EACvC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,8DAA8D;EAChE;;EAEA;IACE,cAAc;IACd,4FAA4F;IAC5F,6BAA6B;IAC7B,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,gCAAgC;EAChC;;IAEE,sCAAsC;IACtC,oCAAoC;IACpC,oDAAoD;EACtD;;EAEA;IACE,uCAAuC;IACvC,mCAAmC;EACrC;;EAEA,+DAA+D;EAC/D;IACE,wCAAwC;IACxC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA,iEAAiE;EACjE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uDAAuD;EACzD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,iEAAiE;EACjE,4DAA4D;EAC5D;;;;IAIE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA,mEAAmE;EACnE;;;;;;;IAOE,eAAe;EACjB;;EAEA,wCAAwC;EACxC;;;IAGE,eAAe;EACjB;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,iEAAiE;EACjE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA,iEAAiE;EACjE;;;;;IAKE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,4CAA4C;EAC9C;;EAEA,iEAAiE;EACjE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA,gEAAgE;EAChE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,uCAAuC;IACvC,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,0FAA0F;EAC1F;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,iEAAiE;EACjE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA,iEAAiE;EACjE;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iEAAiE;EACjE;;;IAGE,eAAe;EACjB;AACF;;AAEA,iEAAiE;AACjE;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;EAClC;AACF","sourcesContent":["/* ============================================================\n   Mobile layer — makes existing pages usable on phones without\n   touching each page. New pages should still be built mobile\n   first with <Col xs={24} md={...}>, not rely on these rescues.\n   ============================================================ */\n\n@media (max-width: 767.98px) {\n  /* ── Dialogs become bottom sheets ───────────────────────── */\n  /* Anchored to the bottom, as tall as their content (up to just under the status bar); the\n     body scrolls between a fixed header and footer so actions stay under the thumb. Inline\n     top/width/max-height set by individual modals are overridden. */\n  .ant-modal:not(.ant-modal-confirm) {\n    position: fixed !important;\n    inset: auto 0 0 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    max-height: calc(100dvh - var(--ds-safe-top) - 12px) !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    transform-origin: 50% 100% !important;\n  }\n\n  .ant-modal:not(.ant-modal-confirm) > div,\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-content {\n    max-height: inherit;\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-content {\n    display: flex;\n    flex-direction: column;\n    border-radius: var(--ds-radius-xl) var(--ds-radius-xl) 0 0;\n    overflow: hidden !important;\n  }\n\n  /* Grab handle */\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-content::before {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    width: 40px;\n    height: 5px;\n    margin-left: -20px;\n    border-radius: 999px;\n    background: var(--ds-border);\n    z-index: 3;\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-header {\n    flex: 0 0 auto;\n    padding: 22px 60px 12px 20px;\n  }\n\n  [dir=\"rtl\"] .ant-modal:not(.ant-modal-confirm) .ant-modal-header {\n    padding: 22px 20px 12px 60px;\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-close {\n    top: 16px;\n    inset-inline-end: 12px;\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-body {\n    flex: 1 1 auto;\n    min-height: 0 !important;\n    max-height: none !important;\n    overflow-y: auto !important;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    padding: var(--ds-space-4) var(--ds-space-5) var(--ds-space-5);\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-footer {\n    flex: 0 0 auto;\n    padding: var(--ds-space-3) var(--ds-space-4) calc(var(--ds-space-3) + var(--ds-safe-bottom));\n    background: var(--ds-surface);\n    box-shadow: 0 -6px 16px rgba(19, 33, 44, 0.05);\n  }\n\n  .ant-modal:not(.ant-modal-confirm) .ant-modal-footer .ant-btn {\n    flex: 1 1 0;\n    height: 48px;\n  }\n\n  /* Slide up instead of zooming */\n  .ant-modal.ant-zoom-enter:not(.ant-modal-confirm),\n  .ant-modal.ant-zoom-appear:not(.ant-modal-confirm) {\n    animation-name: ds-sheet-in !important;\n    animation-duration: 0.28s !important;\n    animation-timing-function: var(--ds-ease) !important;\n  }\n\n  .ant-modal.ant-zoom-leave:not(.ant-modal-confirm) {\n    animation-name: ds-sheet-out !important;\n    animation-duration: 0.2s !important;\n  }\n\n  /* Confirm dialogs stay centered dialogs, just fit the screen */\n  .ant-modal.ant-modal-confirm {\n    max-width: calc(100vw - 32px) !important;\n    margin: 0 auto;\n  }\n\n  .ant-modal-confirm .ant-modal-confirm-btns {\n    display: flex;\n    gap: var(--ds-space-2);\n  }\n\n  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn {\n    flex: 1 1 0;\n    height: 44px;\n    margin: 0 !important;\n  }\n\n  /* ── Drawers never exceed the viewport ─────────────────────── */\n  .ant-drawer-content-wrapper {\n    max-width: 100vw;\n  }\n\n  .ant-drawer-right > .ant-drawer-content-wrapper,\n  .ant-drawer-left > .ant-drawer-content-wrapper {\n    width: min(100vw, var(--ds-drawer-w, 100vw)) !important;\n  }\n\n  .ant-drawer-body {\n    padding: var(--ds-space-4);\n  }\n\n  /* ── Forms: multi-column rows stack into one column ────────── */\n  /* Columns that already declare an xs size are left alone. */\n  .ant-form .ant-row:not(.ant-form-item-row) > .ant-col:not([class*=\"ant-col-xs-\"]),\n  .ant-modal-body\n    .ant-row:not(.ant-form-item-row)\n    > .ant-col[class*=\"ant-col-\"]:not([class*=\"ant-col-xs-\"]) {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .ant-form-horizontal .ant-form-item-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ant-form-horizontal .ant-form-item-label,\n  .ant-form-horizontal .ant-form-item-control {\n    flex: 0 0 auto !important;\n    max-width: 100% !important;\n    text-align: start;\n  }\n\n  /* Fields hard-coded to desktop pixel widths shrink to the screen */\n  .ant-input,\n  .ant-input-affix-wrapper,\n  .ant-input-number,\n  .ant-select,\n  .ant-picker,\n  .ant-picker-range,\n  .ant-input-group-wrapper {\n    max-width: 100%;\n  }\n\n  /* iOS zooms into any field under 16px */\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\n  textarea,\n  select {\n    font-size: 16px;\n  }\n\n  /* Range pickers: show one month at a time */\n  .ant-picker-dropdown .ant-picker-panels {\n    flex-direction: column;\n  }\n\n  .ant-picker-dropdown .ant-picker-range-wrapper {\n    max-width: calc(100vw - 16px);\n  }\n\n  /* ── Tables ────────────────────────────────────────────────── */\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    white-space: nowrap;\n  }\n\n  .ant-table-pagination.ant-pagination {\n    justify-content: center;\n    flex-wrap: wrap;\n    row-gap: var(--ds-space-2);\n  }\n\n  .ant-pagination-options-size-changer,\n  .ant-pagination-options-quick-jumper {\n    display: none !important;\n  }\n\n  /* ── Descriptions: label above value instead of a wide grid ── */\n  .ant-descriptions-bordered .ant-descriptions-view > table,\n  .ant-descriptions-bordered .ant-descriptions-view > table > tbody,\n  .ant-descriptions-bordered .ant-descriptions-row,\n  .ant-descriptions-bordered .ant-descriptions-item-label,\n  .ant-descriptions-bordered .ant-descriptions-item-content {\n    display: block;\n    width: 100%;\n  }\n\n  .ant-descriptions-bordered .ant-descriptions-item-label {\n    border-inline-end: none !important;\n    padding-bottom: var(--ds-space-1) !important;\n  }\n\n  /* ── Page toolbars stack; primary actions become full width ── */\n  .top-right-stuff {\n    float: none !important;\n  }\n\n  .top-right-stuff .ant-flex {\n    flex-direction: column;\n    align-items: stretch;\n    padding: var(--ds-space-3);\n  }\n\n  .top-right-stuff .ant-btn,\n  .top-right-stuff .ant-input-search,\n  .top-right-stuff .ant-select {\n    width: 100% !important;\n  }\n\n  /* ── Tabs: horizontally scrolling pills ───────────────────── */\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav::before {\n    display: none;\n  }\n\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-ink-bar {\n    display: none;\n  }\n\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab {\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: var(--ds-surface);\n    border: 1px solid var(--ds-border-soft);\n    font-size: 0.875rem;\n  }\n\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n    margin-inline-start: 8px;\n  }\n\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-active {\n    background: var(--ds-heading);\n    border-color: var(--ds-heading);\n  }\n\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #fff !important;\n  }\n\n  /* Labels wrapped in a Badge (counts) set their own text color; follow the pill instead. */\n  .ant-tabs-top:not(.ant-tabs-card) > .ant-tabs-nav .ant-tabs-tab-btn .ant-badge {\n    color: inherit;\n  }\n\n  .ant-tabs > .ant-tabs-nav {\n    margin-bottom: var(--ds-space-4);\n  }\n\n  /* ── Cards ─────────────────────────────────────────────────── */\n  .ant-card .ant-card-body {\n    padding: var(--ds-space-4);\n  }\n\n  .ant-card .ant-card-head {\n    padding: 0 var(--ds-space-4);\n    flex-wrap: wrap;\n  }\n\n  /* ── Calendars ─────────────────────────────────────────────── */\n  .fc .fc-toolbar {\n    flex-wrap: wrap;\n    gap: var(--ds-space-2);\n  }\n\n  .fc .fc-toolbar-title {\n    font-size: 1.05rem;\n  }\n\n  .fc .fc-button {\n    padding: 6px 10px;\n  }\n\n  /* ── Media never overflows ─────────────────────────────────── */\n  .app-content img,\n  .app-content video,\n  .app-content iframe {\n    max-width: 100%;\n  }\n}\n\n/* Touch devices: no hover lift/scale effects, bigger hit areas */\n@media (hover: none) {\n  .ant-btn:hover,\n  .ant-card:hover {\n    transform: none !important;\n  }\n\n  .ant-checkbox-wrapper,\n  .ant-radio-wrapper {\n    min-height: 32px;\n    align-items: center;\n  }\n}\n\n@keyframes ds-sheet-in {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes ds-sheet-out {\n  from {\n    transform: translateY(0);\n  }\n  to {\n    transform: translateY(100%);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
